import { modules as modulesApiServices } from '~packages/epk-front-shared/api-client';

import { getVars } from '@/shared/constants/envVars';
import { loadModules } from '@/shared/helpers';

import { generateApiServices, getApiServiceEntityId } from './..';

let loadApiServices = () => {
  console.log('loadApiServices plug :)');
};

try {
  loadApiServices = () =>
    loadModules(import.meta.glob('./*.ts', { eager: true }), fileName =>
      fileName.slice(2, -3)
    );
} catch (error) {
  console.log(error);
}

const apiSettings = JSON.parse(getVars()?.VITE_API_SETTINGS || '{}');
const apiServices = generateApiServices(
  apiSettings.entitiesModulesMap,
  apiSettings.entitiesInfo,
  modulesApiServices
);

// const apiServices = generateApiServices({}, {}, modulesApiServices);
// console.log('apiServices', apiServices);

const apiServicesImported = loadApiServices();
for (const apiServiceName in apiServicesImported) {
  apiServices[getApiServiceEntityId(apiServiceName, true)] = params =>
    new apiServicesImported[apiServiceName](params);
}

export { apiServices };
export default apiServicesImported;
